import { OverlayToaster as BlueprintToaster, Position } from '@blueprintjs/core'

const Singleton = BlueprintToaster.create({
    className: 'recipe-toaster',
    position: Position.TOP_RIGHT,
})

export const Toasts = {
    primary: (message: string | JSX.Element): string =>
        Singleton.show({
            message,
            icon: 'info-sign',
            intent: 'primary',
        }),

    success: (message: string | JSX.Element): string =>
        Singleton.show({
            message,
            icon: 'tick',
            intent: 'success',
        }),

    warning: (message: string | JSX.Element): string =>
        Singleton.show({
            message,
            icon: 'warning-sign',
            intent: 'warning',
        }),

    danger: (message: string | JSX.Element): string =>
        Singleton.show({
            message,
            icon: 'cross',
            intent: 'danger',
        }),

    error: (message: string | JSX.Element): string =>
        Singleton.show({
            message,
            icon: 'cross',
            intent: 'danger',
        }),
}
